import { Component } from '@theme/component';

class LocalPickup extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Local pickup permanently disabled.
    this.setAttribute('hidden', '');
  }

  disconnectedCallback() {
    // Local pickup disabled.
  }
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}